import McToTop from './McToTop.vue'

McToTop.install = function(Vue){
    Vue.component(McToTop.name, McToTop);
}

export default McToTop;